import * as Common from '@/tenant/common';
import { StockBalanceJournal } from '../Journal/StockBalanceJournal';

export class StockTransferItem extends StockBalanceJournal{
  constructor(){
    super('StockTransferItem');
    this.binders.stockTransfer = new Common.ModelBinder(Common.StockTransfer);
    // this.workflowCode="stockTransferItem";
    this.state = Common.StockBalanceJournalStatus.StockTransferWaiting;
    // this.workflowStateId = Common.StockBalanceJournalStatus.StockTransferWaiting;
  }

  public id: number = 0;
  public stockTransferNo: string = '';
  public stockTransfer: Common.StockTransfer = null;
  public seqNo: number = 0;
  public stockTransferItemNo: string = '';
  public specificPurchaseItemId: number = null;

  // public get workflowHolder():string{
  //   return this.stockTransfer ? this.stockTransfer.workflowHolder: super.workflowHolder;
  // }
  // public set workflowHolder(value:string){
  //   super.workflowHolder = value;
  // } 

  // 在庫一覧子画面処理用
  public availableQuantity: number = 0;
  public divideReferencePrice: number = 0;
  public divideReferenceAmount: number = 0;
  public tempNo: number = 0;

  public copy():any {
    const temp = super.copy() as StockTransferItem;
    temp.state = Common.StockBalanceJournalStatus.StockTransferWaiting;
    // temp.workflowStateId = Common.StockBalanceJournalStatus.StockTransferWaiting;
    return temp;
  }

  public get linkStockTransferItem() {
    return String.format('/journal/StockTransferItem?stockTransferItemNo={0}', this.stockTransferItemNo);
  }  
}

export class StockTransferItemQuery extends Common.LoadQuery {
  constructor(){
    super('StockTransferItemQuery',StockTransferItem);
    this.sort = 'stockTransferItemNo';
  }

  public pic: string = '';
  public stockTransferNo: string = '';
  public stockTransferItemNo: string = '';
  public transferFlag:Common.TransferTypes = Common.TransferTypes.None;
  public segmentOut: Common.Segment = null;
  public segmentIn: Common.Segment = null;
  public warehouseOut: Common.Counterpart = null;
  public warehouseIn: Common.Counterpart = null;
  public refNo: string = '';
  public bookDateFrom: Date = null;
  public bookDateTo: Date = null;
  public commodity: Common.Commodity = null;
  public sku: Common.SKU = null;
  public initialSavedOnFrom: Date = null;
  public initialSavedOnTo: Date = null;
  public lastUpdatedOnFrom: Date = null;
  public lastUpdatedOnTo: Date = null;
  public state: Common.StockBalanceJournalStatus = Common.StockBalanceJournalStatus.StockTransferWaiting;
  public holder: string = '';
}

export class StockTransferItemExportQuery extends Common.ExportQuery {
  constructor(sheetName:string, loadQuery:Common.LoadQuery){
    super("",loadQuery);
    this.className = "StockTransferItemExportQuery";
    this.loadQuery = loadQuery;
    this.sheetName = sheetName;
  }
  public loadQuery : Common.LoadQuery;
  public sheetName  :string;
}